document.addEventListener('DOMContentLoaded', (event) => {
	const overlay = document.querySelector('.overlay');
	const columns = document.querySelectorAll('.column');

	overlay.classList.remove('visible');
	setTimeout(() => {
		overlay.classList.remove('active');
	}, 100);

  for (const column of columns) {
		column.classList.add('visible');
  }
})

const articles = document.querySelectorAll('article');

[...articles].forEach((article) => {
  article.addEventListener('click', () => {
    article.classList.toggle('active')
  }, false)
})

const main = document.querySelector('main');
const upcomingButton = document.querySelector('#upcoming');
const runningButton = document.querySelector('#running');

runningButton.addEventListener('click', () => {
  runningButton.classList.add('active')
  upcomingButton.classList.remove('active')
  main.scrollLeft = 0;
}, false)

upcomingButton.addEventListener('click', () => {
  runningButton.classList.remove('active')
  upcomingButton.classList.add('active')
  main.scrollLeft = main.offsetWidth;
}, false)


